import {Component, OnInit} from '@angular/core';
import {Apollo} from "apollo-angular";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {
  createOrden,
  findPersonaByCedula,
  getOnePromotion,
  sucursalesActivas,
  getAdmisionByCodePersona,
  FIND_PROMOTION_BY_COD_PROMOCION_SAM
} from "../../../graphql/graphql.queris";
import {JsonPipe, NgClass, NgForOf, NgIf, NgStyle} from "@angular/common";
import {FormRegisterUserComponent} from "../../form-register-user/form-register-user.component";
import {ServicesSharedService} from "../../services/services-shared.service";
import {FormGroup, FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {ValidateCedula, saltosDeLinea} from "../../../utils/utilities";
import { fadeInUp} from 'ng-animate';
import {transition, trigger, useAnimation} from "@angular/animations";
import { environment } from "../../../../environments/environment";
import {BreadcrumbMktComponent} from "../../../app-mkt/dashboard-mkt/breadcrumb-mkt/breadcrumb-mkt.component";
import {filter} from "rxjs";
import {TopBarComponent} from "../../../top-bar/top-bar.component";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";

@Component({
  selector: 'app-promotions-details',
  standalone: true,
  imports: [NgIf, JsonPipe, FormRegisterUserComponent, NgForOf, ReactiveFormsModule, NgStyle, NgClass, RouterLink, BreadcrumbMktComponent, TopBarComponent, NavBarComponent],
  templateUrl: './promotions-details.component.html',
  styleUrl: './promotions-details.component.css',
  animations: [
    trigger('fadeInUp', [
      transition(':enter', useAnimation(fadeInUp)),
      transition(':leave', useAnimation(fadeInUp))
    ])

  ],
})
export class PromotionsDetailsComponent implements OnInit {
  promotion: any;
  persona: any;
  namePromocion: string= '';
  exists = false;
  personaId = '';
  dataUser = false;
  identificacion = '';
  email: string = '';
  names = '';
  sucursales: any[] = [];
  codPersona = 0;
  admision: any;
  codAdmision = 0;
  codDescuento: any = null;
  register: boolean = false;
  validCedula: boolean = false;
  isLoading = false;
  fadeInUp: any;
  linkPago: string = '';
  manyRequest: boolean = false;
  serviciosMongo: string = '';
  disclaimerMongo: string = '';
  imgMongo: string = '';

  constructor(
    private route: ActivatedRoute,
    private apollo: Apollo,
    private ServicesShared: ServicesSharedService,
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.linkPago = '';
      this.codDescuento = params.get('cod_descuentos');
      if (this.codDescuento !== null) {
        this.getPromocion(parseInt(this.codDescuento, 10));
        this.createOrden.patchValue({codDescuento: this.codDescuento});
      } else {
        console.error('El parámetro cod_descuentos no está presente en la URL.');
      }
    });

    this.getPromocionDetailsMongo(this.codDescuento)

    this.ServicesShared.validatorFormShow.subscribe((data: any) => {
      this.searchId(data.data);
      this.exists = true;
    });

    this.getSucursales();
  }


  convertirPrimeraLetraMayuscula(texto: string): string {
    return texto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  getSucursales() {
    this.apollo.watchQuery({ query: sucursalesActivas })
      .valueChanges.subscribe((result: any) => {
      this.sucursales = result?.data?.getSucursalesActivas.map((item: any) => {
        if (item.sucursal_nombre_comercial === 'MediLink Norte') {
          return { ...item, sucursal_nombre_comercial: 'MediLink Alborada' };
        }
        return item;
      });
      });
  }



  getPromocionDetailsMongo(codPromocionSam: number) {
    this.apollo.query({query: FIND_PROMOTION_BY_COD_PROMOCION_SAM, variables: {codPromocionSam: +codPromocionSam}})
      .subscribe((result: any) => {
        const {servicios, disclaimer, imagenPromocion, nombre} = result.data.findPromotionByCodPromocionSam;
        this.serviciosMongo = saltosDeLinea(servicios);
        this.imgMongo = environment.imgUrl+imagenPromocion ;
        this.disclaimerMongo = disclaimer;
        this.namePromocion= nombre;
      }, (error) => {
        console.error('Error al obtener los datos de la promoción', error);
      })
  }

  getPromocion(cod_descuentos: number) {
    this.apollo.query({query: getOnePromotion, variables: {cod_descuentos}})
      .subscribe((result: any) => {
        this.promotion = result?.data?.getOnePromotion;
        this.exists = true;
      }, (error) => {
        console.error('Error al obtener los datos de la promoción', error);
      });
  }

  async getAdmisionByCodePersona(codPersona: number) {

    this.apollo.query({
      query: getAdmisionByCodePersona,
      variables: {codPersonaPaciente: codPersona, codEmpresaCliente: 2}
    })
      .subscribe((result: any) => {
        this.admision = result?.data?.findAdmisionByCodePersona;
        this.codAdmision = this.admision.codPersonaAdmision;
        this.createOrden.patchValue({codAdmision: this.codAdmision});
      }, (error) => {
        console.error('Error al obtener los datos de la admisión', error);
      });
  }

  getPersonaById(identificacion: string): void {
    const isCedulaValid = ValidateCedula.validarCedula(identificacion);
    if (isCedulaValid) {
      this.apollo.query({query: findPersonaByCedula, variables: {identificacion}})
        .subscribe((result: any) => {
          this.persona = result?.data?.findPersonaByCedula;
          const {cli_nombres_completos, cli_no_identificacion, codPersona, pers_email} = this.persona;
          this.dataUser = true;
          this.names = this.convertirPrimeraLetraMayuscula(cli_nombres_completos);
          this.identificacion = cli_no_identificacion;
          this.email = this.maskEmail(pers_email);
          this.codPersona = codPersona;
          this.validCedula = false;
          this.getAdmisionByCodePersona(this.codPersona);
          this.manyRequest = false;
          this.exists = true;
        }, (error) => {
          if(error.message.includes('No se encontró ninguna persona')){
            this.register = true;
            this.exists = false;
            this.dataUser = false;
            this.personaId = identificacion;
            this.validCedula = false;
            this.manyRequest = false;

          }else if (error.message.includes('ThrottlerException')) {
            console.error('Error interno', error)
            this.manyRequest = true;
            this.exists = true;
            this.register = true;
            this.dataUser = false;
            this.personaId = identificacion;
            this.validCedula = false;
          }

        });
    } else {
      this.validCedula = true;
      this.exists = true;
    }

  }

   maskEmail(email: string): string {
    const [user, domain] = email.split('@');
    const maskedUser = user.slice(0, 4) + '****';
    const maskedDomain = domain.charAt(0) + '****' + domain.slice(domain.lastIndexOf('.'));
    return maskedUser + '@' + maskedDomain;
  }


  searchId(eventOrId?: Event | string): void {
    this.manyRequest = false;
    let identificacion = '';

    if (eventOrId instanceof Event) {
      identificacion = (eventOrId.target as HTMLInputElement).value.trim();
    } else if (typeof eventOrId === 'string') {
      identificacion = eventOrId.trim();
    }

    if (identificacion && identificacion.length > 0 && identificacion.length <= 15) {
      this.getPersonaById(identificacion);
    } else {
      this.exists = true;
      this.dataUser = false;
      this.persona = null;
    }
  }

  createOrden = new FormGroup({
    codSucursal: new FormControl([], [Validators.required, Validators.minLength(1)]),
    codAdmision: new FormControl(this.codAdmision),
    codDescuento: new FormControl(this.codDescuento),
  });

  onclickCreate() {
    this.isLoading = true;
    this.createOrden.markAllAsTouched();
    if (this.createOrden.valid) {
      this.createOrdendata();
    } else {
      this.isCodSucursalInvalid();
      this.isLoading = false;
    }
  }

  createOrdendata() {
    const dataOrden = {
      input: {
        codSucursal: Number(this.createOrden.get('codSucursal')?.value),
        codPromocion: Number(this.codDescuento),
        codPersonaAdmision: Number(this.createOrden.get('codAdmision')?.value),
      }
    };

     this.apollo.mutate({mutation: createOrden, variables: dataOrden})
      .subscribe((result: any) => {
        const createOrdenData = result?.data?.createOrden;
        if (createOrdenData) {
          this.dataUser = false;
          this.identificacion = '';
          this.linkPago = createOrdenData;
        } else {
          console.error('Error al crear la orden');
        }
        this.isLoading = false;
      }, (error) => {
        console.error('Error al crear la orden:');
      });
  }

  isCodSucursalInvalid(): boolean {
    const codSucursalControl = this.createOrden.get('codSucursal');
    return codSucursalControl ? codSucursalControl.invalid && codSucursalControl.touched : false;
  }


  protected readonly environment = environment;
}

